import React from "react";
import useComponentVisible from "../../../hooks/useComponentVisible";
import LanguageIcon from "../SvgIcons/HeaderIcons/LanguageIcon";
import classes from "./LangChange.module.scss";
import LangChangePopUp from "./LangChangePopUp/LangChangePopUp";
const LangChange = ({ top, right }) => {
  const [languageRef, isLanguageModalVisible, setIsLanguageModalVisible] =
    useComponentVisible();
  const handleLanguagePopUp = (e) => {
    setIsLanguageModalVisible(!isLanguageModalVisible);
  };
  const primaryColor = JSON.parse(localStorage.getItem("themeData"))?.CustomData
    ?.PrimaryColor1;
  const isDarkTheme = JSON.parse(
    localStorage.getItem("themeData")
  )?.IsDarkHeaderRequired;
  return (
    <div className={classes.langChange}>
      <div
        className={classes.langChange__container}
        onClick={(e) => {
          e.stopPropagation();
          handleLanguagePopUp();
        }}
      >
        <LanguageIcon fill={isDarkTheme ? "#fff" : primaryColor} />
        <div
          className={
            isDarkTheme
              ? classes.langChangeColor
              : classes.langChange__container__text
          }
        >
          {localStorage.getItem("languageTerm")?.split("-")[0]?.toUpperCase()}
        </div>
      </div>
      {isLanguageModalVisible && (
        <LangChangePopUp
          reference={languageRef}
          handleLanguagePopUp={handleLanguagePopUp}
          top={top}
          right={right}
        />
      )}
    </div>
  );
};

export default LangChange;
